import AppContext from './AppProvider/AppContext';
import AppProvider from './AppProvider/AppProvider';

import Wrapper from './Wrapper/Wrapper';

import Workspace from './Workspace/Workspace';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import NotificationCenter from './NotificationCenter/NotificationCenter';

import NewsCard from './Cards/NewsCard';
import StatCard from './Cards/StatCard';

import Signin from './Authentication/Signin';
import SignUp from './Authentication/SignUp';
import ForgotPassword from './Authentication/ForgotPassword';
import ResetPassword from './Authentication/ResetPassword';
import NotFound from './Errors/NotFound'
import BackendError from './Errors/BackendError';
import NotAllowed from './Errors/NotAllowed';

// FlexHub
import Enquiries from './Enquiries/Enquiries'
import Offices from './Offices/Offices'
import Users from './Users/Users'
//import Tenants from './Tenants/Tenants'
//import Reports from './Reports/Reports'

export {
  AppContext,
  AppProvider,
  Wrapper,
  Workspace,
  Header, Sidebar, NotificationCenter,
  NewsCard, StatCard,
  Signin, SignUp, ForgotPassword, ResetPassword, NotFound, BackendError, NotAllowed,
  Enquiries, Offices, Users
}


// WEBPACK FOOTER //
// ./src/components/index.js